import React from "react";
import { Box, Text, useResponsiveWrapperContext } from "@usap/uicomponents";

const CovidMessage = ({
  borderColor,
  isConfirmation,
  bgColor,
  textAlign,
  fontSize,
  textColor
}) => {
  const { isDesktop } = useResponsiveWrapperContext();

  return (
    <Box
      width="1248px"
      background={{ color: bgColor || "white" }}
      margin={{ vertical: "xxxsmall", horizontal: "auto" }}
      direction="column"
      style={{
        marginBottom: "8px",
        borderColor: borderColor || "#2E4787",
        borderStyle: "solid",
        borderWidth: isConfirmation ? "0" : "0 0 0 4px"
      }}
    >
      <Box
        align="center"
        pad={{ vertical: "small" }}
        style={{
          borderColor: "#E0E0E0",
          borderStyle: "solid",
          borderWidth: isConfirmation ? "1px 1px 1px 1px" : "1px 1px 1px 0",
          padding: "0 15px"
        }}
      >
        <Box width="100%">
          <Text
            as="strong"
            height="21px"
            style={{
              color: textColor || "",
              fontSize: fontSize || "16px",
              marginTop: "10px",
              textAlign: textAlign || "left"
            }}
          >{`Shipping Update`}</Text>
        </Box>
        <Box width="100%">
          <Text
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: isDesktop ? "19px" : "normal",
              paddingBottom: "10px",
              textAlign: textAlign || "left"
            }}
          >
            {`As major carriers like FedEx and UPS have acknowledged, unprecedented demand may cause 1-2 day shipping delays from the ETA given at checkout. We apologize for any inconvenience.`}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default CovidMessage;
